import React from 'react';
import Card from './Card';

const ExamCard = ({base_url}) => {
  const fields = ['difficulty', 'created_date'];
  const endpoint = `${base_url}/exams`;
  return <Card endpoint={endpoint} fields={fields} />;
};

export default ExamCard;